import React from "react";

function TermsCondition() {
  return (
    <section>
      <div className="container my-4">
        <div className="row">
          <div className="offset-md-1 col-md-10 col-12">
            <div>
              <h2 className="text-center mb-5">Terms and Conditions</h2>
              <div>
                <p className="mt-3">
                  These Terms and Conditions govern your access to and use of
                  the information service platform ("Platform") provided by
                  TRUCKLAH PTE. LTD., operating as "Trucklah" in Singapore. By
                  accessing or using the Platform, you affirm that you have
                  read, understood, and agree to these Terms.
                </p>
                <p>
                  You must comply with these Terms and any Community Guidelines.
                  Additionally, you must be of legal age and competent to enter
                  into contracts in your place of residence to use the Platform.
                  By accessing or using the Platform, you acknowledge that you
                  have the authority to agree to these Terms on your own behalf
                  or on behalf of any organization you represent.
                </p>
                <p>
                  If you do not agree to these Terms, please refrain from
                  accessing or using the Platform. It's important to carefully
                  review the "Disclaimer," "Limitations of Liability," and
                  "Indemnity" sections as they limit our liability to you.
                </p>
                <p>
                  Throughout these Terms, "you" or "your" refers to individuals
                  and entities accessing or using the Platform, including any
                  organizations accessing the Platform through their
                  representatives or employees ("Users").
                </p>
                <p>
                  The Platform is governed by applicable Singapore laws and
                  regulations. We reserve the right to modify these Terms, and
                  such changes will be effective when posted on the Platform.
                  Your continued use of the Platform after any changes indicates
                  your acceptance of the revised Terms.
                  <ol className="mt-2">
                    <li>
                      Our Services Our Services connect Users with independent
                      third-party delivery partners ("Delivery Partners") for
                      transportation, logistics, and delivery services. We do
                      not own or provide transportation services ourselves; all
                      services are provided by Delivery Partners.
                    </li>
                    <li>
                      Use of the Software When using our Software, you agree to:
                      <ul>
                        <li>
                          Install the Software only on your mobile device for
                          personal use.
                        </li>
                        <li>
                          Not rent, lease, sublicense, distribute, or transfer
                          the Software to third parties.
                        </li>
                        <li>
                          Not probe, scan, or test the vulnerability of the
                          Platform or breach its security measures.
                        </li>
                        <li>
                          Not modify, reverse engineer, decompile, or create
                          derivative works of the Software.
                        </li>
                        <li>
                          Not disrupt the normal operation of the Software or
                          upload malicious code.
                        </li>
                        <li>
                          Not install or execute the Software on unauthorized
                          devices.
                        </li>
                      </ul>
                    </li>
                    <li>
                      Use of the Services User Account: To use our Services, you
                      must register for an Account and provide accurate personal
                      information as per our Privacy Policy. You are responsible
                      for maintaining the security of your Account and updating
                      your information as necessary. You must use compatible
                      hardware to access our Services, and we reserve the right
                      to terminate your access if we detect unauthorized usage.
                    </li>
                  </ol>
                </p>
              </div>
            </div>
            <div className="mt-5">
              <h4>While utilizing the services, you agree to:</h4>
              <div>
                <p>
                  <ul className="mt-3">
                    <li>
                      Only access the Services through means explicitly
                      authorized by Trucklah.
                    </li>
                    <li>
                      Use the Platform and Services exclusively for personal use
                      and refrain from reselling them to third parties.
                    </li>
                    <li>Not authorize others to access your Account.</li>
                    <li>Maintain only one Account.</li>
                    <li>
                      Prohibit the transfer of your Account to any other
                      individual or legal entity.
                    </li>
                    <li>
                      Refrain from using an Account belonging to another
                      individual without proper authorization.
                    </li>
                    <li>
                      Acknowledge Trucklah's right to include or exclude Users
                      from promotional offers.
                    </li>
                    <li>
                      Utilize the Services solely for lawful purposes,
                      refraining from violating Applicable Law, sharing
                      sensitive personal information without consent, causing
                      harm or annoyance, or engaging in any behavior deemed
                      inappropriate by Trucklah.
                    </li>
                    <li>
                      Maintain the security and confidentiality of your password
                      and identification credentials provided by Trucklah.
                    </li>
                    <li>
                      Promptly submit proof of identity or other requested
                      documentation to Trucklah.
                    </li>
                    <li>
                      Adhere to all Applicable Laws while using the Services.
                    </li>
                    <li>
                      Avoid engaging with Delivery Partners outside of the
                      Platform.
                    </li>
                    <li>
                      Refrain from using any automated or manual methods to
                      access, acquire, or reproduce content from the Platform
                      without explicit authorization from Trucklah.
                    </li>
                    <li>
                      Refrain from attempting to compromise the security or
                      integrity of the Platform's servers.
                    </li>
                    <li>
                      Avoid collecting personally identifiable information from
                      the Platform.
                    </li>
                    <li>
                      Refrain from engaging in threatening, harassing,
                      discriminatory, or otherwise inappropriate behavior while
                      using the Services.
                    </li>
                    <li>
                      Grant Trucklah the rights to share your information with
                      third parties in accordance with its Privacy Policy.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="mt-5">
              <h4>Rules of Use:</h4>
              <div>
                <p>
                  <ul className="mt-3">
                    <li>
                      Users warrant that they own or are authorized agents of
                      the owners of goods and materials in requested shipments.
                    </li>
                    <li>
                      Users agree to these Terms on behalf of themselves and, if
                      applicable, the owners of the shipped goods and materials.
                    </li>
                    <li>
                      Users acknowledge that Delivery Partners transport
                      shipments according to User instructions and do not
                      acquire ownership of the shipments.
                    </li>
                    <li>
                      Users must verify Delivery Partner and vehicle information
                      before accepting services.
                    </li>
                    <li>
                      Users are responsible for providing accurate and
                      executable instructions to Delivery Partners.
                    </li>
                    <li>
                      Users must comply with all laws and regulations regarding
                      the nature, condition, and transportation of goods and
                      materials.
                    </li>
                    <li>
                      Users may not transport prohibited, dangerous, or
                      hazardous materials.
                    </li>
                    <li>
                      Users must ensure shipments are adequately packed and
                      labeled, particularly for fragile items.
                    </li>
                    <li>
                      Trucklah is not responsible for protective services for
                      perishable or temperature-sensitive commodities.
                    </li>
                    <li>
                      Users must provide all necessary information for each
                      shipment.
                    </li>
                    <li>
                      Unclaimed items may be returned to Trucklah if the
                      recipient cannot be reached, with additional fees for
                      handling and re-shipment.
                    </li>
                    <li>
                      Different types of vehicles have specific service
                      limitations and charges.
                    </li>
                    <li>
                      Users must comply with Trucklah's policies regarding
                      Purchase requirements, with additional fees applied as
                      necessary.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="mt-3">
              <p>
                Trucklah reserves the right to terminate your Account, Services,
                and access to the Application if you fail to comply with any of
                the above requirements. Additionally, Trucklah may modify,
                terminate, or suspend the Services to you at any time, without
                prior notice, due to changes in internal policies, Applicable
                Laws, breach of these Terms by you, or for any necessary reason
                at Trucklah’s sole discretion.
              </p>
            </div>
            <div className="mt-5">
              <h4>Service Level Agreement for orders based on vehicle type:</h4>
              <div>
                <p>
                  <ul className="mt-3">
                    <li>
                      Walker/bicycle, motorcycle, car, and MPV point-to-point
                      services are limited to 1 hour of service time upon the
                      driver's arrival or the scheduled order time, whichever is
                      later. Each additional stop adds 30 minutes to the service
                      time.
                    </li>
                    <li>
                      Van and lorry services are limited to 2 hours of service
                      time upon the driver's arrival or the scheduled order
                      time, whichever is later. Each additional stop adds 1 hour
                      to the service time.
                    </li>
                    <li>
                      Immediate orders: Drivers have 30 minutes to arrive at the
                      pickup location upon accepting immediate orders.
                    </li>
                    <li>
                      Scheduled orders: Drivers must arrive at the scheduled
                      pickup time with a grace period of 10 minutes.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="mt-5">
              <h4>Claims:</h4>
              <div>
                <p>
                  <ul className="mt-3">
                    <li>
                      Claims must be made within 24 hours after delivery
                      completion; otherwise, Trucklah bears no liability.
                    </li>
                    <li>
                      Corporate Users must submit claims using the Request Form
                      and will receive a response within 10 working days.
                    </li>
                    <li>
                      All claims must be in writing, accompanied by the delivery
                      order number, contact information, and supporting
                      documents, and sent to info@Trucklah.com.
                    </li>
                    <li>
                      Trucklah's liability for loss or damage is limited to the
                      value of the delivery item or cost of the delivery order,
                      whichever is lower, compensated in Trucklah credits.
                    </li>

                    <li>
                      Compensation for damage or loss is based on Trucklah's
                      assessment of the item's value or replacement cost within
                      compensation limits, provided the claim is justified.
                    </li>
                    <li>
                      Compensation for delicate, perishable, or fragile items
                      depends on the selected vehicle type and Trucklah's
                      discretion. Users must adequately pack and label such
                      items and provide clear handling instructions to Delivery
                      Partners to ensure proper transportation and delivery.
                    </li>
                  </ul>
                </p>
              </div>
              <p>
                Communication: Upon creating an Account, you agree to accept and
                receive communications from Trucklah electronically, including
                via email, text message, calls, and push notifications to the
                mobile device or cellphone number provided. You acknowledge that
                these communications may be generated by automatic telephone
                dialing systems and/or deliver prerecorded messages sent by or
                on behalf of Trucklah, its affiliates, and/or third-party
                contractors, including communications regarding orders placed
                through your registration for the Services. You have the option
                to opt-out by adjusting your notification preferences, though
                note that opting out may affect your use of the Services.
              </p>
              <p>
                Promotional Offers and Credits: Trucklah may, at its discretion,
                offer promotional deals with various features and rates to
                Users. These offers are subject to the Terms and may be valid
                for specific Users as indicated. You agree that promotional
                offers:
                <ul className="mt-3">
                  <li>
                    Must be used by the intended audience, for the intended
                    purpose, and in accordance with the law.
                  </li>
                  <li>
                    Cannot be duplicated, sold, transferred, or made available
                    to the public without Trucklah's express permission.
                  </li>
                  <li>
                    Are subject to specific terms established by Trucklah.
                  </li>
                  <li>Cannot be exchanged for cash or its equivalent.</li>
                  <li>Expire after the specified date in the offer.</li>
                </ul>
              </p>
              <p>
                Trucklah reserves the right to withhold or deduct credits or
                benefits obtained through promotional offers if it determines
                that redemption was in error, fraudulent, illegal, or violated
                applicable terms. Offers may be modified or canceled at any time
                without liability. Gratuitous credits issued by Trucklah are
                subject to specific terms and expire upon the specified date.
              </p>
              <p>
                Other Third-Party Interactions: While using the Platform, you
                may engage with third-party service providers, advertisers, or
                sponsors. Any such interactions and associated terms,
                conditions, warranties, or representations are solely between
                you and the third party. Trucklah and its licensors bear no
                responsibility or liability for such interactions, purchases,
                transactions, or promotions. Trucklah is not liable for any
                agreements between you and third-party providers.
              </p>
            </div>
            <div className="mt-5">
              <h4>1.	Payment for Services:</h4>
              <div>
                <p>
                Except for Corporate Account Users, the use of the Platform is currently free of charge. However, Trucklah reserves the right to introduce fees for Platform usage in the future. Should this occur, you will be notified, and you can decide whether to continue or terminate your Account accordingly.
                </p>
              </div>
            </div>
            <div className="mt-5">
              <h4>
                While utilizing the Services, you acknowledge and agree to the
                following:
              </h4>
              <div>
                <ul>
                  <li>
                    Trucklah will charge you any applicable tolls, taxes, and
                    fees ("Charges") for the transportation services and other
                    services provided by the Delivery Partner. These Charges are
                    due upon placing an order and will be deducted from your
                    Trucklah Wallet or designated payment method.
                  </li>
                  <li>
                    Charges paid are non-refundable, except as determined by
                    Trucklah on a case-by-case basis.
                  </li>
                  <li>
                    Charges are quoted in Singapore Dollars and include
                    applicable taxes.
                  </li>
                  <li>
                    Any priority or add-on fees are voluntary but, once
                    selected, will be added to the Charges and are obligatory.
                  </li>
                  <li>
                    Trucklah reserves the right to adjust Charges based on
                    various factors.
                  </li>
                  <li>
                    Availability of resources may affect service requests, and
                    Trucklah will inform you if your application cannot be
                    processed.
                  </li>
                  <li>
                    Trucklah may refund the equivalent amount paid if unable to
                    process an application for any reason, at its discretion.
                  </li>
                  <li>
                    You may cancel service requests before the Delivery
                    Partner's arrival, but a cancellation fee may apply.
                  </li>
                  <li>
                    Receipts are issued upon successful payment, and a negative
                    balance in your Trucklah Wallet may result in unavailable
                    Services.
                  </li>
                  <li>
                    Miscellaneous charges, such as storage or dismantling fees,
                    must be agreed upon with the Delivery Partner before the job
                    begins. Contact Trucklah Customer Service if there are any
                    disputes.
                  </li>
                  <li>
                    If additional charges are requested by the Delivery Partner
                    and were not part of the original order, you must inform
                    Trucklah Customer Service before payment.
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-5">
              <h4>Payment Methods:</h4>
              <div>
                <ul>
                  <li>Cash Payment: Charges can be paid in cash.</li>
                  <li>
                    Trucklah Wallet: Top-up and purchase credits through
                    Trucklah Wallet are available for in-app service requests.
                    Trucklah reserves the right to revise credit package prices
                    or limits without prior notice. All credits are prepaid and
                    non-refundable unless required by law or determined by
                    Trucklah.
                    <ul>
                      <li>
                        Credit Card: Payments can be made using a credit card
                        through Payment Gateways or Payment Processors provided
                        by Trucklah's affiliates or partners. You authorize
                        these entities to process transactions and maintain an
                        Account.
                      </li>
                      <li>
                        Bank-in: Top-up requests through bank-in are processed
                        after payment clearance and Trucklah approval.
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div className="mt-5">
              <h4>1. Intellectual Property Ownership:</h4>
              <div>
                <p>
                  Trucklah, along with its licensors where applicable, holds all
                  rights, title, and interest, including related intellectual
                  property rights, to the Platform and Services. These Terms do
                  not transfer ownership rights to you regarding the Platform,
                  Services, or any intellectual property owned by Trucklah.
                  Company names, logos, and product names associated with the
                  Platform and Services are trademarks or intellectual property
                  of Trucklah or third parties, and no license is granted to use
                  them. You agree not to remove, alter, or obscure any
                  copyright, trademark, or other proprietary rights notices. By
                  providing User Content to Trucklah, you grant Trucklah a
                  worldwide, perpetual, irrevocable, transferable, royalty-free
                  license to use, copy, modify, create derivative works of,
                  distribute, publicly display, and perform such User Content.
                  You acknowledge that Trucklah acts as a passive channel for
                  User Content distribution and is not responsible for its
                  accuracy or content. You represent that your User Content is
                  original, does not infringe third-party rights, and you have
                  the right to grant the license. You agree to indemnify
                  Trucklah, its affiliates, and licensors against any costs,
                  expenses, damages, or liabilities related to your User Content
                  or use of the Platform or Services. Trucklah reserves the
                  right to block or remove any User Content that violates these
                  Terms. Trucklah does not accept confidential ideas,
                  information, or suggestions. Any submissions become the
                  property of Trucklah, and Trucklah has the right to use them
                  without compensation or obligation to keep them confidential.
                </p>
                <p>
                  You may use information from the Platform for personal,
                  non-commercial purposes, provided you do not modify or remove
                  proprietary notices.
                </p>
                <p className="fw-medium">Disclaimers:</p>
                <p>
                  The Services are provided "as is" and "as available," without
                  any representation or warranty regarding reliability,
                  timeliness, quality, or availability. Trucklah does not
                  guarantee uninterrupted or error-free Services. Trucklah does
                  not control the quality, safety, or ability of third-party
                  providers, and your use of the Services is at your own risk.
                  Third-party providers, including Delivery Partners, are not
                  agents or employees of Trucklah. Trucklah does not control or
                  endorse User Content or third-party content linked to the
                  Services and cannot guarantee that the Services are free of
                  viruses or harmful components.
                </p>
              </div>
            </div>
            <div className="mt-5">
              <h4>1. Limitation of Liability:</h4>
              <div>
                <p>
                  Except for Corporate Account Users, Trucklah shall not be
                  liable for: • Damage, defect, or change in items/property due
                  to inadequate packaging. • Damage, defect, or change in
                  items/property occurring before transportation begins. • The
                  quality of Services, which relies on the Delivery Partner
                  providing transportation/logistics services. • Unaccepted
                  bookings. • Damages resulting from using or being unable to
                  use the Services, including errors in call center numbers,
                  network issues, malware, viruses, or
                  inaccuracies/incompleteness. • The suitability of
                  communication mediums (e.g., mobile, email), with
                  responsibility on you to report any errors promptly. • Any
                  direct, indirect, punitive, incidental, special, or
                  consequential damages, including profit and loss, regardless
                  of contract, tort, negligence, strict liability, or other
                  theories. • Lost items during Services, where Trucklah will
                  make best efforts to locate them but is not liable for losses
                  or damages.
                </p>
                <p>
                  Except for Corporate Account Users, Trucklah's aggregate
                  liability under these Terms or Services, whether in contract,
                  tort, warranty, or otherwise, will not exceed the Charges of
                  the order or value of the Shipments (whichever is less).
                  Compensation will be in Trucklah credits.
                </p>
              </div>
            </div>
            <div className="mt-5">
              <h4>1. Indemnity:</h4>
              <div>
                <p>
                  By accepting these Terms and using the Service, you agree to
                  defend, indemnify, and hold Trucklah, its affiliates,
                  licensors, officers, directors, other users, employees,
                  attorneys, and agents harmless from any claims, costs,
                  damages, losses, liabilities, and expenses arising from: •
                  Your violation of these Terms or any Applicable Law. • Your
                  violation of any third-party rights, including Delivery
                  Partners arranged via the Platform. • Your use or misuse of
                  the Service.
                </p>
              </div>
            </div>
            <div className="mt-5">
              <h4>1. Governing Law:</h4>
              <div>
                <p>
                  Except as stated in these Terms, they are governed by
                  Singapore laws. For cross-jurisdictional orders (e.g.,
                  Philippines users placing Singapore orders), Trucklah reserves
                  the right to determine applicable terms. Any disputes shall be
                  settled by mediation, arbitration, or Singapore courts as
                  Trucklah deems appropriate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TermsCondition;
